
import Vue from "vue";
import { Purchase } from "@/models/base";
import AppInfoInput from "@/components/common/InfoInput.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => Purchase,
			required: true
		}
	},
	computed: {
		subtractablePercent():number {
			return this.value.getSubtractablePercent();
		}
	},
	components: {
		AppInfoInput
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
